import { FC } from 'react';

type Props = {
	className?: string;
};

const NotificationsIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			fill='none'>
			<path
				opacity='0.4'
				d='M2.42237 12.2158C2.25225 13.331 3.01284 14.1051 3.94409 14.4908C7.51434 15.9699 12.4827 15.9699 16.0529 14.4908C16.9842 14.1051 17.7447 13.331 17.5747 12.2158C17.4701 11.5304 16.9531 10.9597 16.5701 10.4024C16.0684 9.66351 16.0186 8.85751 16.0185 8.00006C16.0185 4.68631 13.3233 2 9.99851 2C6.67378 2 3.97856 4.68631 3.97856 8.00006C3.97848 8.85751 3.92863 9.66351 3.42694 10.4024C3.04392 10.9597 2.52693 11.5304 2.42237 12.2158Z'
				fill='#2B2B2B'
			/>
			<path
				d='M2.42237 12.2158C2.25225 13.331 3.01284 14.1051 3.94409 14.4908C7.51434 15.9699 12.4827 15.9699 16.0529 14.4908C16.9842 14.1051 17.7447 13.331 17.5747 12.2158C17.4701 11.5304 16.9531 10.9597 16.5701 10.4024C16.0684 9.66351 16.0186 8.85751 16.0185 8.00006C16.0185 4.68631 13.3233 2 9.99851 2C6.67378 2 3.97856 4.68631 3.97856 8.00006C3.97848 8.85751 3.92863 9.66351 3.42694 10.4024C3.04392 10.9597 2.52693 11.5304 2.42237 12.2158Z'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.79688 15.6001C7.16367 16.9803 8.45729 18.0001 9.99691 18.0001C11.5365 18.0001 12.8301 16.9803 13.1969 15.6001'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default NotificationsIconDuotone;
